import { useState } from 'react';

const ContactModal = ({ isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState('email');
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [status, setStatus] = useState('');

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you can add email sending logic (e.g., EmailJS or backend API)
        setStatus('Message sent successfully!');
        setTimeout(() => {
            setStatus('');
            setFormData({ name: '', email: '', message: '' });
            onClose();
        }, 2000);
    };

    const socials = [
        { name: 'Facebook', url: 'https://facebook.com', icon: '📘' },
        { name: 'Instagram', url: 'https://instagram.com', icon: '📷' },
        { name: 'Twitter', url: 'https://twitter.com', icon: '🐦' },
        { name: 'WhatsApp', url: 'https://wa.me/', icon: '💬' }
    ];

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>×</button>

                <div className="modal-tabs">
                    <button
                        className={`tab-btn ${activeTab === 'email' ? 'active' : ''}`}
                        onClick={() => setActiveTab('email')}
                    >
                        Send Email
                    </button>
                    <button
                        className={`tab-btn ${activeTab === 'socials' ? 'active' : ''}`}
                        onClick={() => setActiveTab('socials')}
                    >
                        Socials
                    </button>
                </div>

                {activeTab === 'email' ? (
                    <div className="tab-content">
                        <h2>Contact a Trainer</h2>
                        {status && <div className="success">{status}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Your Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Your Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="5"
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary-modal">Send Message</button>
                        </form>
                    </div>
                ) : (
                    <div className="tab-content">
                        <h2>Connect With Us</h2>
                        <div className="socials-grid">
                            {socials.map((social) => (
                                <a
                                    key={social.name}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-link"
                                >
                                    <span className="social-icon">{social.icon}</span>
                                    <span className="social-name">{social.name}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactModal;
